import { isNull } from 'lodash/fp';
import React, { useCallback, useEffect, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { useWindowResize } from '../../../hooks/useWindowResize';
import styles from './DocumentViewer.module.scss';
import { PDFViewer, ReactPdf } from './PDFViewer';
import { DocumentViewerType, getNumberOfPages, setDocumentViewerType, setNumberOfPages } from './store';
import { MimeType } from '../../constants/MimeType';

interface DocumentPreviewViewerProps {
    url: string | null;
    mimeType: string | null;
    type: DocumentViewerType;
    selectedPage?: number | null;
    setSelectedPage?: (page: number | null) => void;
    width?: number;
}

export const DocumentPreviewViewer: React.FC<DocumentPreviewViewerProps> = ({ url, mimeType, selectedPage, setSelectedPage, type, width }) => {
    const numPages = useAppSelector(getNumberOfPages);
    const dispatch = useAppDispatch();
    const setNumPages = useCallback((numberOfPages: number | null) => dispatch(setNumberOfPages(numberOfPages)), [dispatch]);

    const onLoadSuccess = useCallback(({ numPages }: ReactPdf) => setNumPages(numPages), [setNumPages]);

    const [screenWidth] = useWindowResize();
    const pageWidth = useMemo(() => width || (screenWidth * 0.5) - 40, [width, screenWidth]);

    useEffect(() => {
        dispatch(setDocumentViewerType(type));
        return () => {
            dispatch(setDocumentViewerType(null));
        };
    }, [dispatch, type]);

    if (mimeType === MimeType.PDF && !isNull(url)) {
        return (
            <div className={styles.pdfViewerWrapper}>
                <PDFViewer
                    onLoadSuccess={onLoadSuccess}
                    resetNumPages={() => setNumPages(null)}
                    numPages={numPages}
                    pdfUrl={url}
                    width={pageWidth}
                    selectedPage={selectedPage}
                    setSelectedPage={setSelectedPage}
                />
            </div>
        );
    }

    return null;
};
